module.exports = __webpack_public_path__ + "img/turizmi-icon.1925faba.svg";